"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CirrusProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const socket_1 = require("@yanzi/socket");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const use_persisted_state_1 = __importDefault(require("use-persisted-state"));
const contexts_1 = require("../../contexts");
const useHostState = use_persisted_state_1.default('yanzi-cirrus-host', process.env.NODE_ENV === 'development' ? window.sessionStorage : window.localStorage);
const HOSTS = [
    ['ifangtang.net', 'cirrus.ifangtang.net'],
    ['dev.yanzi.cloud', 'eu.yanzi.cloud'],
    ['yanzi.dev', 'eu.yanzi.dev'],
    ['localhost', 'eu.yanzi.dev'],
    ['', 'cirrus5.yanzi.se'],
];
const DEFAULT_HOST = (_b = (_a = HOSTS.find(([suffix]) => window.location.hostname.endsWith(suffix))) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : HOSTS[HOSTS.length - 1][1];
function CirrusProvider({ children }) {
    const [host, setHost] = useHostState(DEFAULT_HOST);
    const searchParamsHost = useSearchParamsHost();
    react_1.useEffect(() => {
        if (searchParamsHost) {
            setHost(searchParamsHost);
        }
    }, [searchParamsHost, setHost]);
    const [signInIteration, recreateSocket] = react_1.useState(0);
    const socket = react_1.useMemo(() => {
        const socket = socket_1.createSocket(`wss://${host}/cirrusAPI`);
        socket.id = `${host}-${signInIteration}-${Math.random()}`;
        return socket;
    }, [host, signInIteration]);
    react_1.useEffect(() => {
        return () => {
            socket.close();
        };
    }, [socket]);
    const clear = react_1.useCallback(() => {
        recreateSocket(old => old + 1);
    }, [recreateSocket]);
    const contextValue = react_1.useMemo(() => ({ socket, host, setHost, clear }), [
        clear,
        host,
        setHost,
        socket,
    ]);
    return jsx_runtime_1.jsx(contexts_1.CirrusContext.Provider, Object.assign({ value: contextValue }, { children: children }), void 0);
}
exports.CirrusProvider = CirrusProvider;
function useSearchParamsHost() {
    const { search } = react_router_dom_1.useLocation();
    const searchParamsHost = react_1.useMemo(() => {
        return new URLSearchParams(search).get('host');
    }, [search]);
    return searchParamsHost;
}
//# sourceMappingURL=index.js.map